import React from "react";
import Card from "../shared/Card";

const StatusTimeline = ({ status }) => {
  const steps = [
    {
      key: "IN_REVIEW",
      label: "In Review",
      description: "Panel is reviewing materials",
    },
    {
      key: "DECISION_REACHED",
      label: "Decision Reached",
      description: "Panel has made a decision",
    },
    {
      key: "PENDING_PUBLICATION",
      label: "Pending Publication",
      description: "Awaiting admin approval",
    },
    {
      key: "PUBLISHED",
      label: "Published",
      description: "Publicly available",
    },
    {
      key: "CLOSED",
      label: "Closed",
      description: "Panel process complete",
    },
  ];

  const currentIndex = steps.findIndex((step) => step.key === status);

  const getStepStatus = (index) => {
    if (index < currentIndex) return "completed";
    if (index === currentIndex) return "current";
    return "pending";
  };

  const getStepColor = (stepStatus) => {
    if (stepStatus === "completed") return "bg-green-500 text-white";
    if (stepStatus === "current") return "bg-custom-blue text-white";
    return "bg-gray-200 text-gray-600";
  };

  const getTextColor = (stepStatus) => {
    if (stepStatus === "current") return "text-custom-blue";
    if (stepStatus === "completed") return "text-gray-700";
    return "text-gray-400";
  };

  return (
    <Card title="Panel Lifecycle">
      <div className="space-y-4">
        {steps.map((step, index) => {
          const stepStatus = getStepStatus(index);
          return (
            <div
              key={step.key}
              className={`flex items-center ${getTextColor(stepStatus)}`}
            >
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0 ${getStepColor(
                  stepStatus
                )}`}
              >
                {stepStatus === "completed" ? "✓" : index + 1}
              </div>
              <div>
                <p className="font-medium">{step.label}</p>
                <p className="text-xs text-gray-500">{step.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default StatusTimeline;
